
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { ClientSubscription } from "@/models/Client";
import { useTranslation } from "react-i18next";

interface SessionCardProps {
  subscription: ClientSubscription;
  sessionCount?: number;
  onSessionChange: (subscriptionId: string, value: string) => void;
  getWorkoutTypeName: (workoutTypeId: string) => string;
}

const SessionCard: React.FC<SessionCardProps> = ({
  subscription,
  sessionCount,
  onSessionChange,
  getWorkoutTypeName,
}) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-sm md:text-base greek-text">
            {getWorkoutTypeName(subscription.workoutTypeId)}
          </CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="grid grid-cols-2 gap-4 text-xs md:text-sm">
          <div>
            <Label className="text-muted-foreground greek-text">
              {t('clients.monthlyLimit')}
            </Label>
            <div className="font-medium">{subscription.sessionsPerMonth}</div>
          </div>
          <div>
            <Label className="text-muted-foreground greek-text">
              {t('clients.remaining')}
            </Label>
            <div className="font-medium">
              {subscription.sessionsPerMonth - (sessionCount || 0)}
            </div>
          </div>
        </div>
        
        <div>
          <Label htmlFor={`sessions-${subscription.id}`} className="text-sm greek-text">
            {t('clients.sessionsCompleted')}
          </Label>
          <Input
            id={`sessions-${subscription.id}`}
            type="number"
            value={sessionCount ?? 0}
            onChange={(e) => onSessionChange(subscription.id, e.target.value)}
            className="mt-1"
            placeholder="0"
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default SessionCard;
